export default __webpack_public_path__ + "static/media/404-portrait@2x.38c73eb9.jpg";